/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetJobRunDetailResponse,
  GetMyJobsResponse
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const getMyJobs = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetMyJobsResponse>(
      {url: `/api/jobs/mine`, method: 'GET', signal
    },
      );
    }
  



export const getGetMyJobsQueryKey = () => {
    return [
    `/api/jobs/mine`
    ] as const;
    }

    
export const getGetMyJobsQueryOptions = <TData = Awaited<ReturnType<typeof getMyJobs>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyJobs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyJobsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyJobs>>> = ({ signal }) => getMyJobs(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyJobs>>>
export type GetMyJobsQueryError = ErrorType<unknown>


export function useGetMyJobs<TData = Awaited<ReturnType<typeof getMyJobs>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyJobs>>,
          TError,
          Awaited<ReturnType<typeof getMyJobs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyJobs<TData = Awaited<ReturnType<typeof getMyJobs>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyJobs>>,
          TError,
          Awaited<ReturnType<typeof getMyJobs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyJobs<TData = Awaited<ReturnType<typeof getMyJobs>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyJobs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyJobs<TData = Awaited<ReturnType<typeof getMyJobs>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyJobs>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyJobsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getJobRunDetail = (
    jobRunId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetJobRunDetailResponse>(
      {url: `/api/jobs/${jobRunId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetJobRunDetailQueryKey = (jobRunId?: string,) => {
    return [
    `/api/jobs/${jobRunId}`
    ] as const;
    }

    
export const getGetJobRunDetailQueryOptions = <TData = Awaited<ReturnType<typeof getJobRunDetail>>, TError = ErrorType<void>>(jobRunId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobRunDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobRunDetailQueryKey(jobRunId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobRunDetail>>> = ({ signal }) => getJobRunDetail(jobRunId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(jobRunId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobRunDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobRunDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getJobRunDetail>>>
export type GetJobRunDetailQueryError = ErrorType<void>


export function useGetJobRunDetail<TData = Awaited<ReturnType<typeof getJobRunDetail>>, TError = ErrorType<void>>(
 jobRunId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobRunDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobRunDetail>>,
          TError,
          Awaited<ReturnType<typeof getJobRunDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobRunDetail<TData = Awaited<ReturnType<typeof getJobRunDetail>>, TError = ErrorType<void>>(
 jobRunId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobRunDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobRunDetail>>,
          TError,
          Awaited<ReturnType<typeof getJobRunDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobRunDetail<TData = Awaited<ReturnType<typeof getJobRunDetail>>, TError = ErrorType<void>>(
 jobRunId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobRunDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetJobRunDetail<TData = Awaited<ReturnType<typeof getJobRunDetail>>, TError = ErrorType<void>>(
 jobRunId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobRunDetail>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobRunDetailQueryOptions(jobRunId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const dismissJobRun = (
    jobRunId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/jobs/${jobRunId}/dismiss`, method: 'POST', signal
    },
      );
    }
  


export const getDismissJobRunMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissJobRun>>, TError,{jobRunId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof dismissJobRun>>, TError,{jobRunId: string}, TContext> => {

const mutationKey = ['dismissJobRun'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissJobRun>>, {jobRunId: string}> = (props) => {
          const {jobRunId} = props ?? {};

          return  dismissJobRun(jobRunId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DismissJobRunMutationResult = NonNullable<Awaited<ReturnType<typeof dismissJobRun>>>
    
    export type DismissJobRunMutationError = ErrorType<unknown>

    export const useDismissJobRun = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissJobRun>>, TError,{jobRunId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dismissJobRun>>,
        TError,
        {jobRunId: string},
        TContext
      > => {

      const mutationOptions = getDismissJobRunMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const retryFailedJobSteps = (
    jobRunId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/jobs/${jobRunId}/retry-failed`, method: 'POST', signal
    },
      );
    }
  


export const getRetryFailedJobStepsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryFailedJobSteps>>, TError,{jobRunId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof retryFailedJobSteps>>, TError,{jobRunId: string}, TContext> => {

const mutationKey = ['retryFailedJobSteps'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryFailedJobSteps>>, {jobRunId: string}> = (props) => {
          const {jobRunId} = props ?? {};

          return  retryFailedJobSteps(jobRunId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RetryFailedJobStepsMutationResult = NonNullable<Awaited<ReturnType<typeof retryFailedJobSteps>>>
    
    export type RetryFailedJobStepsMutationError = ErrorType<unknown>

    export const useRetryFailedJobSteps = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryFailedJobSteps>>, TError,{jobRunId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryFailedJobSteps>>,
        TError,
        {jobRunId: string},
        TContext
      > => {

      const mutationOptions = getRetryFailedJobStepsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const retryJobStep = (
    jobRunId: string,
    stepId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/jobs/${jobRunId}/steps/${stepId}/retry`, method: 'POST', signal
    },
      );
    }
  


export const getRetryJobStepMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryJobStep>>, TError,{jobRunId: string;stepId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof retryJobStep>>, TError,{jobRunId: string;stepId: string}, TContext> => {

const mutationKey = ['retryJobStep'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryJobStep>>, {jobRunId: string;stepId: string}> = (props) => {
          const {jobRunId,stepId} = props ?? {};

          return  retryJobStep(jobRunId,stepId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RetryJobStepMutationResult = NonNullable<Awaited<ReturnType<typeof retryJobStep>>>
    
    export type RetryJobStepMutationError = ErrorType<unknown>

    export const useRetryJobStep = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryJobStep>>, TError,{jobRunId: string;stepId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryJobStep>>,
        TError,
        {jobRunId: string;stepId: string},
        TContext
      > => {

      const mutationOptions = getRetryJobStepMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    